var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { staticClass: "header flex-shrink-0", attrs: { type: "dark" } },
    [
      _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
      _vm._v(" "),
      _c(
        "b-navbar-brand",
        { attrs: { href: "#" }, on: { click: _vm.updateApp } },
        [
          _c("div", [
            _c("img", {
              staticClass: "logo",
              attrs: { src: "/static/logo.png" }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _vm.restPoint
        ? _c("div", { staticClass: "ml-2 mr-2" }, [
            _c(
              "span",
              {
                staticClass:
                  "d-flex align-items-center fw-bold font-weight-bold",
                staticStyle: { color: "#fff" }
              },
              [
                _c("icon", {
                  staticClass: "mr-2",
                  attrs: { name: "map-marker-alt" }
                }),
                _vm._v(" " + _vm._s(_vm.restPoint.address) + "\n      ")
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isShowMemoBtn && _vm.memoUrl && _vm.memoUrl !== "<none>"
        ? _c(
            "a",
            {
              staticClass: "btn btn-secondary mr-2",
              attrs: { href: _vm.memoUrl, target: "_blank" }
            },
            [_vm._v("\n      Памятка\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.userRole === _vm.USER_ROLE_CALL_CENTER
        ? _c("wrapper-worker-stats")
        : _vm._e(),
      _vm._v(" "),
      _vm.userRole === _vm.USER_ROLE_CALL_CENTER
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c(
                "time-delivery-form",
                {
                  staticClass: "ml-3",
                  attrs: { "current-value": _vm.pickupDeliveryStats },
                  on: {
                    "updated-time": function($event) {
                      return _vm.setStatsDelivery(
                        true,
                        $event.hours,
                        $event.minutes
                      )
                    }
                  }
                },
                [
                  _c("span", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v("Самовывоз:")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "time-delivery-form",
                {
                  staticClass: "ml-3",
                  attrs: { "current-value": _vm.delDeliveryStats },
                  on: {
                    "updated-time": function($event) {
                      return _vm.setStatsDelivery(
                        false,
                        $event.hours,
                        $event.minutes
                      )
                    }
                  }
                },
                [
                  _c("span", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v("Доставка:")
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { "is-nav": "", id: "nav_collapse" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto d-flex flex-wrap" },
            [
              _vm._t("navbar-display"),
              _vm._v(" "),
              _vm.userRole === _vm.USER_ROLE_LOGISTICIAN
                ? _c("preorders-print-picker", { staticClass: "mr-5" })
                : _vm._e(),
              _vm._v(" "),
              _vm.userRole !== null
                ? _c("worker-action", {
                    on: { showOrHideOrdersWindow: _vm.showOrHideOrdersWindow }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isShowCookerRatingBtn &&
              _vm.cookerRatingUrl &&
              _vm.cookerRatingUrl !== "<none>"
                ? _c(
                    "a",
                    {
                      staticClass: "btn btn-secondary mr-2",
                      attrs: { href: _vm.cookerRatingUrl, target: "_blank" }
                    },
                    [_vm._v("\n              Рейтинг\n            ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isShowExitBtn
                ? _c(
                    "b-button",
                    {
                      attrs: { size: "sm" },
                      on: {
                        click: function($event) {
                          return _vm.$userControl.logout()
                        }
                      }
                    },
                    [_vm._v("\n              Выйти\n            ")]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _vm.isCourier
            ? _c(
                "b-dropdown",
                { staticClass: "ml-1", attrs: { text: "Меню", right: "" } },
                [
                  _c("b-dropdown-item", { attrs: { to: "/deliveryOrder" } }, [
                    _vm._v("Доставки")
                  ]),
                  _vm._v(" "),
                  _c("b-dropdown-item", { attrs: { to: "/courierStats" } }, [
                    _vm._v("Статистика")
                  ]),
                  _vm._v(" "),
                  _vm.courierRatingUrl && _vm.courierRatingUrl !== "<none>"
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            href: _vm.courierRatingUrl,
                            target: "_blank"
                          }
                        },
                        [_vm._v("\n            Рейтинг\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.memoUrl && _vm.memoUrl !== "<none>"
                    ? _c(
                        "b-dropdown-item",
                        { attrs: { href: _vm.memoUrl, target: "_blank" } },
                        [_vm._v("\n            Памятка\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$userControl.logout()
                        }
                      }
                    },
                    [_vm._v("\n            Выйти\n          ")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4088e726", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4088e726","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavbarHeader.vue
// module id = null
// module chunks = 